import {defineStore} from "pinia";
import {ref} from "vue";
import {getAllBaseData} from "@/apis/base-data-api";

// 所有基础数据 {}
const baseData = ref();

// 问题标签表 List
const baseDataIssueTagList = ref([]);
// 物料分类表 List
const baseDataMaterialCategoryList = ref([]);
// 物料信息表 List
const baseDataMaterialInfoList = ref([]);
// 操作描述表 List
const baseDataOperationDescriptionList = ref([]);
// 操作方式表 List
const baseDataOperationMethodList = ref([]);
// 虫害类型表 List
const baseDataPestTypeList = ref([]);
// 区域管理表 List
const baseDataRegionManagementList = ref([]);
// 风险类型表 List
const baseDataRiskTypeList = ref([]);
// 门店分类物料配置表 List
const baseDataStoreCategoryMaterialConfigList = ref([]);
// 门店集团定制配置表 List
const baseDataStoreCustomConfigList = ref([]);

// 问题标签表 Map
const baseDataIssueTagMap = ref(new Map());
// 物料分类表 Map
const baseDataMaterialCategoryMap = ref(new Map());
// 物料信息表 Map
const baseDataMaterialInfoMap = ref(new Map());
// 操作描述表 Map
const baseDataOperationDescriptionMap = ref(new Map());
// 操作方式表 Map
const baseDataOperationMethodMap = ref(new Map());
// 虫害类型表 Map
const baseDataPestTypeMap = ref(new Map());
// 区域管理表 Map
const baseDataRegionManagementMap = ref(new Map());
// 风险类型表 Map
const baseDataRiskTypeMap = ref(new Map());
// 门店分类物料配置表 Map
const baseDataStoreCategoryMaterialConfigMap = ref(new Map());
// 门店集团定制配置表 Map
const baseDataStoreCustomConfigMap = ref(new Map());

export const useBaseDataStore = defineStore('baseData', () => {
  const initBaseData = () => {
    getAllBaseData({}).then((res) => {
      baseData.value = res.data;
      // 处理List，并将List转换为Map
      handleBaseDataIssueTag();
      handleBaseDataMaterialCategory();
      handleBaseDataMaterialInfo();
      handleBaseDataOperationDescription();
      handleBaseDataOperationMethod();
      handleBaseDataPestType();
      handleBaseDataRegionManagement();
      handleBaseDataRiskType();
      handleBaseDataStoreCategoryMaterialConfig();
      handleBaseDataStoreCustomConfig();
    });
  };
  
  return  {
    // 初始化所有基础数据
    initBaseData,
    // 所有基础数据
    baseData,
    // List
    baseDataIssueTagList,
    baseDataMaterialCategoryList,
    baseDataMaterialInfoList,
    baseDataOperationDescriptionList,
    baseDataOperationMethodList,
    baseDataPestTypeList,
    baseDataRegionManagementList,
    baseDataRiskTypeList,
    baseDataStoreCategoryMaterialConfigList,
    baseDataStoreCustomConfigList,
    // Map
    baseDataIssueTagMap,
    baseDataMaterialCategoryMap,
    baseDataMaterialInfoMap,
    baseDataOperationDescriptionMap,
    baseDataOperationMethodMap,
    baseDataPestTypeMap,
    baseDataRegionManagementMap,
    baseDataRiskTypeMap,
    baseDataStoreCategoryMaterialConfigMap,
    baseDataStoreCustomConfigMap
  }
})

function handleBaseDataIssueTag() {
  // 从baseData中获取数据
  baseDataIssueTagList.value = baseData.value?.baseDataIssueTagList || [];
  // 转换为Map，key为tagCode
  baseDataIssueTagMap.value = new Map(baseDataIssueTagList.value?.map(item => [item.tagCode, item]));
}

function handleBaseDataMaterialCategory() {
  // 从baseData中获取数据
  baseDataMaterialCategoryList.value = baseData.value?.baseDataMaterialCategoryList || [];
  // 转换为Map，key为categoryCode
  baseDataMaterialCategoryMap.value = new Map(baseDataMaterialCategoryList.value?.map(item => [item.categoryCode, item]));
}

function handleBaseDataMaterialInfo() {
  // 从baseData中获取数据
  baseDataMaterialInfoList.value = baseData.value?.baseDataMaterialInfoList || [];
  // 转换为Map，key为materialCode
  baseDataMaterialInfoMap.value = new Map(baseDataMaterialInfoList.value?.map(item => [item.materialCode, item]));
}

function handleBaseDataOperationDescription() {
  // 从baseData中获取数据
  baseDataOperationDescriptionList.value = baseData.value?.baseDataOperationDescriptionList || [];
  // 转换为Map，key为descriptionCode
  baseDataOperationDescriptionMap.value = new Map(baseDataOperationDescriptionList.value?.map(item => [item.descriptionCode, item]));
}

function handleBaseDataOperationMethod() {
  // 从baseData中获取数据
  baseDataOperationMethodList.value = baseData.value?.baseDataOperationMethodList || [];
  // 转换为Map，key为methodCode
  baseDataOperationMethodMap.value = new Map(baseDataOperationMethodList.value?.map(item => [item.methodCode, item]));
}

function handleBaseDataPestType() {
  // 从baseData中获取数据
  baseDataPestTypeList.value = baseData.value?.baseDataPestTypeList || [];
  // 转换为Map，key为pestCode
  baseDataPestTypeMap.value = new Map(baseDataPestTypeList.value?.map(item => [item.pestCode, item]));
}

function handleBaseDataRegionManagement() {
  // 从baseData中获取数据
  baseDataRegionManagementList.value = baseData.value?.baseDataRegionManagementList || [];
  // 转换为Map，key为regionCode
  baseDataRegionManagementMap.value = new Map(baseDataRegionManagementList.value?.map(item => [item.regionCode, item]));
}

function handleBaseDataRiskType() {
  // 从baseData中获取数据
  baseDataRiskTypeList.value = baseData.value?.baseDataRiskTypeList || [];
  // 转换为Map，key为riskCode
  baseDataRiskTypeMap.value = new Map(baseDataRiskTypeList.value?.map(item => [item.riskCode, item]));
}

function handleBaseDataStoreCategoryMaterialConfig() {
  // 从baseData中获取数据
  baseDataStoreCategoryMaterialConfigList.value = baseData.value?.baseDataStoreCategoryMaterialConfigList || [];
  // 转换为Map，key为storeCategoryId
  baseDataStoreCategoryMaterialConfigMap.value = new Map(baseDataStoreCategoryMaterialConfigList.value?.map(item => [item.storeCategoryId, item]));
}

function handleBaseDataStoreCustomConfig() {
  // 从baseData中获取数据
  baseDataStoreCustomConfigList.value = baseData.value?.baseDataStoreCustomConfigList || [];
  // 转换为Map，key为storeId
  baseDataStoreCustomConfigMap.value = new Map(baseDataStoreCustomConfigList.value?.map(item => [item.storeId, item]));
}